import type { ReactNode } from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import { OfflineBanner } from "./components/OfflineBanner";
import { ToastProvider } from "./components/ToastProvider";
import { queryClient } from "./queryClient";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <OfflineBanner />
          {children}
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  );
}
